"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimitReachedError = void 0;
var tslib_1 = require("tslib");
var CustomError_1 = require("./CustomError");
var RateLimitReachedError = /** @class */ (function (_super) {
    tslib_1.__extends(RateLimitReachedError, _super);
    function RateLimitReachedError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RateLimitReachedError;
}(CustomError_1.CustomError));
exports.RateLimitReachedError = RateLimitReachedError;
//# sourceMappingURL=RateLimitReachedError.js.map